import React, { FC, useContext } from 'react'
import { Paper, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import Title from '../Title'
import { DataContext } from '../../contexts/DataProvider'

const CountInfo: FC = () => {
  const { activeContract } = useContext(DataContext)

  if (!activeContract) {
    return <Title>Select contract</Title>
  }
  const SyledPaper = styled(Paper)(() => ({
    padding: '1rem',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  }))

  return (
    <SyledPaper>
      <Title>Users at the moment:</Title>
      <Typography mt={2}>Submitted users:</Typography>
      <Typography component="p" variant="h4">
        {activeContract.submittedUsers ? activeContract.submittedUsers : '-'}
      </Typography>
      <Typography>Active users:</Typography>
      <Typography component="p" variant="h4">
        {activeContract.activeUsers ? activeContract.activeUsers : '-'}
      </Typography>
    </SyledPaper>
  )
}
export default CountInfo
